export default "__VITE_ASSET__BGprxjHw__"